import type { Pinia } from 'pinia'

import { useAuthorizationStore } from '@/stores/authorization'
import { useCalculationStore } from '@/stores/calculation'
import { useHardwareProfileStore } from '@/stores/hardwareProfile'
import { useProjectStore } from '@/stores/project'
import { useProjectUserStore } from '@/stores/projectUser'

export const resetAuthenticatedStores = (pinia?: Pinia) => {
  useAuthorizationStore(pinia).resetState()
  useCalculationStore(pinia).resetAll()
  useHardwareProfileStore(pinia).resetAll()
  useProjectStore(pinia).resetAll()
  useProjectUserStore(pinia).resetState()
}
